














































































































































































import VueOptions from '@utils/VueOptions'

settings =
  name: 'PayoutBoardOfferResourceListItem'

  resources:
    offer:
      resourceName: 'offer'
      slug: 'offers/:item.id'
      fetch: false

  vue:
    props: ['item', 'rowSize', 'actions', 'selected', 'backgroundColor']

    computed:
      bill: -> @item.bill || {}
      payoutBankAccount: -> @bill.ctx?.payout_bank_account || {}
      audienceListing: -> @ctxAudienceListing @item
      vendorListing: -> @ctxVendorListing @item
      listing: -> if @audienceListing.id then @audienceListing else @vendorListing
      supplier: -> @ctxSupplierOrg @item
      organizer: -> @listing.owner

      # Payout Status

      payoutStatus: ->
        @item.payout_status

      payoutArc: ->
        @item.payout_arc || {}

      payoutStatusBy: ->
        switch @payoutStatus
          when 'approved' then @payoutArc.approved_by
          when 'canceled' then @payoutArc.canceled_by
          else null

      payoutStatusAt: ->
        switch @payoutStatus
          when 'approved' then @payoutArc.approved_at
          when 'canceled' then @payoutArc.canceled_at
          else null

      payoutStatusAtLong: ->
        @$options.filters.formatDate(@payoutStatusAt, 'llll') if @payoutStatusAt

      payoutStatusTooltip: ->
        "By #{@payoutStatusBy}" if @payoutStatusBy

      payoutStatusClass: ->
        switch @payoutStatus
          when 'approved' then 'bg-green text-white'
          when 'canceled' then 'bg-red-lightest text-red'
          else 'bg-grey-dark text-white'

      # Bill

      isBillOverdue: ->
        !!@bill.is_overdue

      billAmountDelta: ->
        return 0 unless @bill.amount
        @bill.amount - @item.final_payout_in_dollars

      billApprovers: ->
        approvers = @bill.approvers || []
        approvers.map (approver) =>
          badgeType:   @mapApproverStatusToBadgeType(approver)
          statusClass: @mapApproverStatusToTextClass(approver)
          firstName:   approver.user_info.first_name
          lastName:    approver.user_info.last_name
          email:       approver.user_info.email
          status:      approver.status_name
          updatedAt:   approver.status_changed_date

      billVendorIndicators: ->
        indicators = []

        return indicators if @isEmptyValue(@payoutBankAccount)

        { onboarded, w9_form, payment_method, invites_sent } = @payoutBankAccount

        if onboarded
          indicators.push { title: 'Onboarded', tagClass: 'bg-green text-white' }
        else if w9_form || payment_method
          if w9_form
            indicators.push { title: 'W-9 Uploaded', tagClass: 'bg-green text-white' }
          else
            indicators.push { title: 'W-9 Missing', tagClass: 'bg-red-lightest text-red' }
          if payment_method
            indicators.push { title: "Pay by: #{payment_method}", tagClass: 'bg-green text-white' }
          else
            indicators.push { title: 'Missing Payment', tagClass: 'bg-red-lightest text-red' }
        else if invites_sent > 0
          indicators.push { title: "Invitations sent: #{invites_sent}", tagClass: 'bg-draft text-white' }
        else
          indicators.push { title: 'Invitation not sent', tagClass: 'bg-grey-dark text-white' }

        indicators

      # Actions

      canApprovePayout: ->
        @payoutStatus is 'pending_approval'

      canCancelPayout: ->
        !@isBillApprovalStartedOrCompleted && @payoutStatus isnt 'canceled'

      canUndoPayout: ->
        !@isBillApprovalStartedOrCompleted && @payoutStatus isnt 'pending_approval'

      canSyncWithBill: ->
        @item.bill_number?

      isBillApprovalStartedOrCompleted: ->
        !!@bill.is_approval_started_or_completed

      lastSyncedAt: ->
        return 'never' unless @bill.last_synced_at
        @$options.filters.fromNow(@bill.last_synced_at)

    methods:
      hiCopyToClipboard: (event, value) ->
        @copyToClipboard event, value
        @showFlash { 'Message:': 'Copied to clipboard!' }

      hiMarkAsPayoutApproved: ->
        @triggerResource 'offer', 'mark_as_payout_approved'
      onOfferMarkAsPayoutApproved: ->
        @fetch 'offer'

      hiMarkAsPayoutCanceled: ->
        @triggerResource 'offer', 'mark_as_payout_canceled'
      onOfferMarkAsPayoutCanceled: ->
        @fetch 'offer'

      hiUndoPayout: ->
        @triggerResource 'offer', 'undo_payout_status'
      onOfferUndoPayoutStatus: ->
        @fetch 'offer'

      hiSyncWithBill: ->
        @triggerResource 'offer', 'sync_with_bill'
      onOfferSyncWithBill: ->
        @fetch 'offer'

      # Bill

      billApprovalStatusClass: (bill) ->
        switch bill.approval_status_name
          when 'approved' then 'bg-green text-white'
          when 'denied'   then 'bg-red-lightest text-red'
          else 'bg-grey-dark text-white'

      billPaymentStatusClass: (bill) ->
        switch bill.payment_status_name
          when 'paid_in_full'    then 'bg-green text-white'
          else 'bg-grey-dark text-white'

      mapApproverStatusToBadgeType: (approver) ->
        switch approver.status_name
          when 'approved' then 'success'
          when 'denied'   then 'danger'
          else 'info'

      mapApproverStatusToTextClass: (approver) ->
        switch approver.status_name
          when 'approved' then 'text-green'
          when 'denied'   then 'text-red'
          else 'text-grey-dark'

export default VueOptions.vue settings
